import { create } from "zustand";
import { CentralSlice, createCentralStore } from "./central.store";
import { ClientSlice, createClientStore } from "./client.store";
import { ClientFormsSlice, createClientFormsStore } from "./client-forms.store";
import { ConfigSlice, createConfigStore } from "./config.store";
import { RegionsSlice, createRegionsSlice } from "./regions.slice";
import { PriceListsSlice, createPriceListsSlice } from "./price-lists.slice";
import { OnboardingSlice, createOnboardingSlice } from "./onboarding.slice";
import { CatalogsSlice, createCatalogsSlice } from "./catalogs.slice";
import { SubscriptionSlice, createSubscriptionSlice } from "./subscription.slice";

interface CentralStoreTypes extends CentralSlice, ClientSlice, ClientFormsSlice, ConfigSlice, RegionsSlice, PriceListsSlice, OnboardingSlice, CatalogsSlice, SubscriptionSlice {}

export const useCentralStore = create<CentralStoreTypes>((...args) => ({
	...createCentralStore(...args),
	...createClientStore(...args),
	...createClientFormsStore(...args),
	...createConfigStore(...args),
	...createRegionsSlice(...args),
	...createPriceListsSlice(...args),
	...createOnboardingSlice(...args),
	...createCatalogsSlice(...args),
	...createSubscriptionSlice(...args),
}));
